import * as types from 'modules/dealers/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @typedef {import('modules/global/generic.types.js').Page} State */

/** @type {State} */
const initialState = {
  number: 0,
  totalElements: 0,
  totalPages: 0,
  size: 10,
};

/**
 *
 * @param {State} state
 * @param {import("modules/global/generic.types").Action<import('modules/global/generic.types.js').PageContent<import('modules/dealers/types.js').Dealer>>} action
 * @return {State}
 */
const updateState = (state, { payload }) => ({
  ...state,
  ...payload.page,
});

/**
 * @param {State} state
 * @returns {State}
 */
const resetState = ({ size }) => ({ ...initialState, size });

export default createReducer(initialState, {
  [types.GET_MODAL_DEALERS_SUCCESS]: updateState,
  [types.GET_MODAL_DEALERS_FAILURE]: resetState,
});
